<template>
  <slc-alert-dialog
    icon-name="clock"
    :show="!$route.path.startsWith('/unauthorized') && showNoFeedsDialog"
    @close="showNoFeedsDialog = false"
  >
    <span slot="title">Wir stellen gerade Ihre Inhalte bereit</span>
    <span slot="message"
      >Bitte melden Sie sich in ein paar Minuten erneut an. Für Rückfragen
      wenden Sie sich bitte an unseren dpa-Kundenservice. Vielen Dank!</span
    >
  </slc-alert-dialog>
</template>

<script>
import { defineComponent, computed, ref, watch } from "vue";
import SlcAlertDialog from "@/components/SlcAlertDialog.vue";
import useAuthentication from "@/composition/useAuthentication";

export default defineComponent({
  components: { SlcAlertDialog },
  setup() {
    const { profile } = useAuthentication();
    const hasSelectFeeds = computed(() => !!profile.value?.selectFeeds?.length);
    const showNoFeedsDialog = ref(false);

    watch(
      hasSelectFeeds,
      () => {
        showNoFeedsDialog.value = !hasSelectFeeds.value;
      },
      { immediate: true }
    );

    return { showNoFeedsDialog };
  }
});
</script>
